export const UUID_NULL = '00000000-0000-0000-0000-000000000000';

export const SUPER_ADMIN_ROLE = -1;
export const ADMIN_ROLE = 0;
export const GROUP_MANAGEMENT_ROLE = 2;
export const GROUP_CONTROL_ROLE = 4;
export const GROUP_MONITORING_ROLE = 8;
export const STATION_MANAGEMENT_ROLE = 16;
export const STATION_CONTROL_ROLE = 32;
export const STATION_MONITORING_ROLE = 64;
export const STATION_SETUP_ROLE = 128;
export const USER_ROLE = 256;

export const ROLE_HASH = {
  0: "Hệ thống",
  2: "Quản lý địa bàn",
  4: "Điều khiển địa bàn",
  8: "Giám sát địa bàn",
  16: "Quản lý trạm",
  32: "Điều khiển trạm",
  64: "Giám sát trạm",
  128: "Lắp đặt",
  256: "Chưa cài đặt"
}

export const ROLE_FILTER = [
  {
    value: 0,
    text: "Hệ thống"
  }, {
    value: 2,
    text: "Quản lý địa bàn"
  }, {
    value: 4,
    text: "Điều khiển địa bàn"
  }, {
    value: 8,
    text: "Giám sát địa bàn"
  }, {
    value: 16,
    text: "Quản lý trạm"
  }, {
    value: 32,
    text: "Điều khiển trạm"
  }, {
    value: 64,
    text: "Giám sát trạm"
  }, {
    value: 128,
    text: "Lắp đặt"
  }, {
    value: 256,
    text: "Chưa cài đặt"
  }
]

export const roleSuperAdmin = (role) => {
  return role === SUPER_ADMIN_ROLE
}

export const roleAdmin = (role) => {
  return role === ADMIN_ROLE
}

export const roleGroupManagement = (role) => {
  return role === ADMIN_ROLE || role === GROUP_MANAGEMENT_ROLE
}

export const roleGroupControl = (role) => {
  return role === ADMIN_ROLE || role === GROUP_MANAGEMENT_ROLE || role === GROUP_CONTROL_ROLE
}

export const roleGroupMonitoring = (role) => {
  return role === ADMIN_ROLE || role === GROUP_MANAGEMENT_ROLE || role === GROUP_CONTROL_ROLE || role === GROUP_MONITORING_ROLE
}

export const roleStationManagement = (role) => {
  return role === ADMIN_ROLE || role === GROUP_MANAGEMENT_ROLE || role === STATION_MANAGEMENT_ROLE
}

export const roleStationControl = (role) => {
  return role === ADMIN_ROLE || role === GROUP_MANAGEMENT_ROLE || role === GROUP_CONTROL_ROLE || role === STATION_CONTROL_ROLE
}

export const roleStationMonitoring = (role) => {
  return role === ADMIN_ROLE || role === GROUP_MANAGEMENT_ROLE || role === GROUP_CONTROL_ROLE || role === GROUP_MONITORING_ROLE || role === STATION_MANAGEMENT_ROLE || role === STATION_CONTROL_ROLE || role === STATION_MONITORING_ROLE
}

export const HUB_STATE_RUN = 0;
export const HUB_STATE_STOP = 1;
export const HUB_STATE_IN_ACTIVE = 2;
export const HUB_STATE_ERROR = 3;

export const PERMISSION_DENIED = 2;
export const PERMISSION_READ = 4;
export const PERMISSION_CONTROL = 6;
export const PERMISSION_UPDATE = 8;
export const PERMISSION_DELETE = 16;

export const CHANELL_STATUS_BOTH = 'statusboth';
export const CHANELL_NEW_STATUS = 'newstatus';
export const CHANNEL_NEW_ALARM_STATE = 'newalarmstate';
export const CHANNEL_STATION_CONNECTION_STATUS = 'stationconnectionstatus';
export const CHANNEL_NEW_EVENT = 'newevent';
export const CHANNEL_EVENT_BOTH = 'eventboth';
export const CHANNEL_NEW_CONFIG = 'newconfig';
export const CHANNEL_BELL_STATUS = 'bellstatus';

export const SOCKET_MSG_TYPE_TOKEN = 0
export const SOCKET_MSG_TYPE_HUB_INFO = 1
export const SOCKET_MSG_TYPE_NEW_STATION = 2
export const SOCKET_MSG_TYPE_NEW_ALARM_STATE = 3
export const SOCKET_MSG_TYPE_NEW_STATUS = 4
export const SOCKET_MSG_TYPE_NEW_EVENT = 5
export const SOCKET_MSG_TYPE_STATION_CONNECTION_STATUS = 6
export const SOCKET_MSG_TYPE_NEW_CONFIG = 7
export const SOCKET_MSG_TYPE_BELL_STATUS = 8
export const SOCKET_MSG_TYPE_UNKNOWN = 9

export const CONFIG_CATEGORY_DEVICE = 1
export const CONFIG_CATEGORY_DEVICE_ACTIVE = 2
export const CONFIG_CATEGORY_DEVICE_THRESHOLE = 3
export const CONFIG_CATEGORY_DEVICE_LOG = 4
export const CONFIG_CATEGORY_DEVICE_AUTO_OFF = 5
export const CONFIG_CATEGORY_SCRIPT = 6
export const CONFIG_CATEGORY_SCRIPT_ACTIVE = 7
export const CONFIG_CATEGORY_SCHEDULE = 8
export const CONFIG_CATEGORY_SCHEDULE_ACTIVE = 9
export const CONFIG_CATEGORY_PHONE = 10
export const CONFIG_CATEGORY_BIN = 11

export const DEVICE_STATUS_NA_INDEX = 15;
export const DEVICE_AIN_VALUE_RATIO = 10;

//DIN SENSOR
export const SUB_CATEGORY_SMOKE = 0;
export const SUB_CATEGORY_DOOR = 1;
export const SUB_CATEGORY_MOTION = 2;
export const SUB_CATEGORY_GLASS = 3;
export const SUB_CATEGORY_GAS = 4;
export const SUB_CATEGORY_HEAT_EXCEED = 5;
export const SUB_CATEGORY_BUTTON = 6;

//LAMP
export const SUB_CATEGORY_LAMP = 7; //đèn sợi đốt / led
export const SUB_CATEGORY_LAMP_COMPACT = 8; //đèn compact
export const SUB_CATEGORY_LAMP_SLEEP = 9; //đèn ngủ đầu giường
export const SUB_CATEGORY_LAMP_TABLE = 10; //đèn bàn
export const SUB_CATEGORY_LAMP_CEILLING = 11; //đèn trần

export const SUB_CATEGORY_LAMP_DECOR = 31;
export const SUB_CATEGORY_LAMP_CHANDELIER = 35;

export const SUB_CATEGORY_FAN_1 = 12; //Quạt
export const SUB_CATEGORY_FAN_2 = 13; //Q.hút
export const SUB_CATEGORY_FAN_CEILLING = 14; //Q.trần
export const SUB_CATEGORY_OUTLET = 15;
export const SUB_CATEGORY_WATERING = 16;
export const SUB_CATEGORY_HEATER = 17;
export const SUB_CATEGORY_BELL = 18;
export const SUB_CATEGORY_ALARM_BELL = 19;
export const SUB_CATEGORY_DO_NOT_DISTURB = 20;
export const SUB_CATEGORY_CURTAIN = 21;
export const SUB_CATEGORY_AIR_CONTROLLER = 22;
export const SUB_CATEGORY_PUMP = 23;

//AIN
export const SUB_CATEGORY_TEMPERATURE = 24;
export const SUB_CATEGORY_HUMIDITY = 25;
export const SUB_CATEGORY_V_AC_METER = 26;

export const SUB_CATEGORY_POWER_METER = 27;
export const SUB_CATEGORY_POWER_METER_DAY = 28;
export const SUB_CATEGORY_POWER_METER_MONTH = 29;
export const SUB_CATEGORY_POWER_METER_COUNTER = 38;

export const SUB_CATEGORY_LUMINARY = 30;
export const SUB_CATEGORY_TEMPERATURE_OUTSIDE = 32;
export const SUB_CATEGORY_HUMIDITY_OUTSIDE = 33;
export const SUB_CATEGORY_DOOR_IN_HOUSE = 34;
export const SUB_CATEGORY_PROJECTOR = 36;
export const SUB_CATEGORY_PROJECTOR_SCREEN = 37;

export const DEVICE_STATUS_STATE_OFF = 0;
export const DEVICE_STATUS_STATE_ON = 1;
export const DEVICE_STATUS_STATE_LOW = 0;
export const DEVICE_STATUS_STATE_NORMAL = 1;
export const DEVICE_STATUS_STATE_HIGH = 2;
export const DEVICE_STATUS_STATE_DISCONNECTED = 15;
export const DEVICE_STATUS_COLOR_ON = "#ff9421";
export const DEVICE_STATUS_COLOR_OFF = "#727272";
export const DEVICE_STATUS_COLOR_TOO_LOW = "#4dbce9";
export const DEVICE_STATUS_COLOR_LOW = "#5ca0cc";
export const DEVICE_STATUS_COLOR_NORMAL = "#76b729";
export const DEVICE_STATUS_COLOR_HIGH = "#fd4425";
export const DEVICE_STATUS_COLOR_TOO_HIGH = "#d6563a";
export const DEVICE_STATUS_COLOR_DISCONNECTED = "#2f5612";

export const DEVICE_STATUS_AIN_STATE_TOO_LOW = 0;
export const DEVICE_STATUS_AIN_STATE_LOW = 1;
export const DEVICE_STATUS_AIN_STATE_NORMAL = 2;
export const DEVICE_STATUS_AIN_STATE_HIGH = 3;
export const DEVICE_STATUS_AIN_STATE_TOO_HIGH = 4;

export const DEVICE_STATUS_METER_STATE_NORMAL = 0;
export const DEVICE_STATUS_METER_STATE_HIGH = 1;

export const COMMAND_OFF = 0;
export const COMMAND_ON = 1;
export const COMMAND_OPEN = 1;
export const COMMAND_CLOSE = 2;
export const COMMAND_PAUSE = 0;
export const COMMAND_AIR_ON_16 = 16;
export const COMMAND_AIR_ON_17 = 17;
export const COMMAND_AIR_ON_18 = 18;
export const COMMAND_AIR_ON_19 = 19;
export const COMMAND_AIR_ON_20 = 20;
export const COMMAND_AIR_ON_21 = 21;
export const COMMAND_AIR_ON_22 = 22;
export const COMMAND_AIR_ON_23 = 23;
export const COMMAND_AIR_ON_24 = 24;
export const COMMAND_AIR_ON_25 = 25;
export const COMMAND_AIR_ON_26 = 26;
export const COMMAND_AIR_ON_27 = 27;
export const COMMAND_AIR_ON_28 = 28;
export const COMMAND_AIR_ON_29 = 29;
export const COMMAND_AIR_ON_30 = 30;
export const COMMAND_AIR_MODE_AUTO = 2;
export const COMMAND_AIR_MODE_COOL = 3;
export const COMMAND_AIR_MODE_DRY = 4;
export const COMMAND_AIR_MODE_FAN = 5;
export const COMMAND_AIR_MODE_HEAT = 6;
export const COMMAND_AIR_WIND_AUTO = 7;
export const COMMAND_AIR_WIND_LOW = 8;
export const COMMAND_AIR_WIND_MED = 9;
export const COMMAND_AIR_WIND_HI = 10;
export const COMMAND_AIR_SWING_AUTO = 11;
export const COMMAND_AIR_SWING_1 = 12;
export const COMMAND_AIR_SWING_2 = 13;
export const COMMAND_AIR_SWING_3 = 14;
export const COMMAND_AIR_SWING_4 = 15;

export const CAMERA_SNAPSHOT_INTERVAL = 60000;
export const CAMERA_SNAPSHOT_FULL = 0;
export const CAMERA_SNAPSHOT_MEDIUM = 640;
export const CAMERA_SNAPSHOT_SMALL = 320;



// WEBPACK FOOTER //
// ./src/constants/defaultValues.js